/**
 * Rozšířený typ nástroje mapového editoru.

 * Pozor, tento typ je podporován pouze v režimu napojení
 * na nového klienta Mapio {@link ClientMode.NEW_EDITOR}.
 */
export enum ExtendedEditorToolType {
    /**
     * "Nástroj" představující seskupení více nástrojů pod jedním jménem.
     */
    GROUP = 'GROUP',

    /**
     * Nástroj pro vytvoření nového zákresu do vrstvy.
     * Jednotlivé nástroje pro tvorbu zákresu se zobrazí až po výběru editovatelné
     * vrstvy a jsou závislé na povolených geometriích vybrané vrstvy.
     */
    NEW_ITEM = 'NEW_ITEM',
}
